import CityPage from "../CityPage";

export default function VillaPark() {
  return <CityPage slug="villa-park" />;
}
